import { type FC } from "react";
import { Link } from "react-router";

import { faHouse } from "@fortawesome/pro-duotone-svg-icons/faHouse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useNavRail } from "@application/contexts/nav_rail_context";

// Case-detail icon-rail content (🅓). One level into a case the status filters no
// longer apply, so the nav recedes to a thin rail — just Home. Body only: the
// width-animating shell, the ≡ slide-away, and the shared gear live in
// DashboardRail.
export const DetailRail: FC = () => {
  const rail = useNavRail();
  // Return to the cases list at the same status filter the user left it on.
  const homeTo = `/dashboard/projects${rail?.listSearch ?? ""}`;

  return (
    <Link
      to={homeTo}
      title="Home"
      aria-label="Home"
      className="flex size-10 items-center justify-center rounded-[10px] text-base text-slate-400 hover:bg-slate-300 hover:text-slate-700"
    >
      <FontAwesomeIcon icon={faHouse} />
    </Link>
  );
};
